import { render, staticRenderFns } from "./product-sales.vue?vue&type=template&id=f61dafb4&"
import script from "./product-sales.vue?vue&type=script&lang=js&"
export * from "./product-sales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports